module.exports = __webpack_public_path__ + "img/ucreagent.660018a0.png";